import { whiteColor, blackColors } from 'assets/jss/material-dashboard-pro-react';

const departmentsPickerStyle = (theme) => ({
	selectedItem: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-start',
		'& p': {
			marginBottom: 0,
			lineHeight: theme.direction === 'rtl' ? 1 : 'normal',
		},
		'& svg': {
			color: blackColors[4],
			width: '24px',
			height: '24px',
			marginRight: '8px',
		},
	},
	alternativeSelect: {
		'& > div > div:first-of-type': {
			paddingLeft: 0,
		},
	},
	departmentsWrapper: {
		paddingLeft: '42px',
		display: 'flex',
		flexWrap: 'wrap',
		'& > div': {
			marginRight: '4px',
			transition: 'all .1s ease-in-out',
			padding: '9px 8px 7px 8px',
			display: 'flex',
			alignItems: 'center',
			borderRadius: '16px',
			marginBottom: '8px',
			cursor: 'pointer',
			userSelect: 'none',
			'& p': {
				marginBottom: 0,
			},
			'& svg': {
				color: whiteColor,
				marginLeft: '2px',
				width: '16px',
				height: '16px',
				position: 'relative',
				bottom: '1px',
			},
			'&:last-of-type': {
				marginRight: 0,
			},
		},
	},
	notSelected: {
		opacity: 0.5,
	},
	accountWrapper: {
		display: 'flex',
		width: '100%',
		justifyContent: 'flex-start',
		alignItems: 'center',
	},
	disabledAccountWrapper: {
		marginBottom: '15px',
	},
	disabledItem: {
		flexWrap: 'wrap',
		'& svg': {
			color: blackColors[6],
		},
	},
});

export default departmentsPickerStyle;
